/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/customPeriod.scss';

import {ChangeKeyFunction, CloseButton, WithBackground} from '@dvrd/dvr-controls';
import IDate from '@dvrd/idate';
import React, {MouseEventHandler} from 'react';
import {BolmateButton, DvrdDatePicker} from "../../controls";

interface Props {
    onChange: ChangeKeyFunction;
    onClose: MouseEventHandler;
    onSubmit: MouseEventHandler;
    periodStart: IDate | null;
    periodEnd: IDate | null;
    active: boolean;
    max?: IDate;
}

export default function CustomPeriod(props: Props) {
    const {periodStart, periodEnd, active, onClose, onSubmit, onChange, max} = props;

    function renderBody() {
        return (
            <div className='body-container'>
                <DvrdDatePicker onChange={onChange('start')} value={periodStart} label='Vanaf' dateFormat='DD-MM-YYYY'
                                placeholder='dd-mm-jjjj' max={max} closeOnChange/>
                <DvrdDatePicker onChange={onChange('end')} value={periodEnd} label='Tot en met'
                                dateFormat='DD-MM-YYYY' placeholder='dd-mm-jjjj' max={max ?? IDate.now()}
                                closeOnChange/>
            </div>
        )
    }

    return (
        <WithBackground active={active} onClose={onClose}>
            <div className='custom-period default-popup'>
                <div className='header-container'>
                    <label className='header-title'>Aangepaste periode</label>
                    <CloseButton onClick={onClose}/>
                </div>
                {renderBody()}
                <div className='footer-container btn-2'>
                    <BolmateButton onClick={onClose} label='Annuleren' secondary/>
                    <BolmateButton onClick={onSubmit} label='Toepassen' disabled={!periodStart || !periodEnd}/>
                </div>
            </div>
        </WithBackground>
    )
}